__turbopack_context__.v({
  "leadSection": "slider-module-scss-module__L_RWVa__leadSection",
  "next": "slider-module-scss-module__L_RWVa__next",
  "prev": "slider-module-scss-module__L_RWVa__prev",
  "slider": "slider-module-scss-module__L_RWVa__slider",
});
